import { render, staticRenderFns } from "./TBody.vue?vue&type=template&id=d1ae5512&scoped=true&"
import script from "./TBody.vue?vue&type=script&lang=ts&"
export * from "./TBody.vue?vue&type=script&lang=ts&"
import style0 from "./TBody.vue?vue&type=style&index=0&id=d1ae5512&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ae5512",
  null
  
)

export default component.exports